import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectViewNotFoundRoute: InvariantJiraRoute = {
	name: 'classic-business-view-not-found',
	path: '/jira/core/projects/:projectKey/not-found',
	exact: true,
};
